const config = {
    appname: process.env.REACT_APP_NAME || 'Zachary Nespral',
  }
  
  export default config;